import React, {useEffect, useState} from "react";
import Gauge from "react-svg-gauge";
import UserInfoWrapper from "./userinfo.style";

const LatestActivity = (props) => {
  const [data, setData] = useState(props.data);
  useEffect(() => {
    if(props.data) {
      if(props.data.Battery_Stat){
        setData(props.data)
      }
    }

  }, [props.data]);
  return (
    <UserInfoWrapper className="fill-height">
      <div className="card roe-shadow-2 fill-height">
        <div className="card-body">
          <h4 className="card-title fs-20">Company Info</h4>
          <div className="row">
            <div className="col-md-6 aligner-wrapper text-center">
              <Gauge
                value={data.Volts !== null ? parseFloat(data.Volts) : 0}
                width={200}
                height={140}
                label={data.Battery_Stat !== null ? data.Battery_Stat : 0}
                color="#563c91"
                valueLabelStyle={{ fontSize: "30px" }}
              />
            </div>
            <div className="col-md-6 legend-wrapper">
              <div className="d-flex flex-column justify-content-center">
                { (data.EIS_Stat !== null) &&
                  <div className="d-flex align-items-center">
                    <div style={{flex: "none"}} className="dot-indicator nevy mt-1 mr-2"></div>
                    <h4  style={{flex: "none"}} className="text-muted ml-3">EIS : &nbsp;</h4>
                    <br></br>
                    <h4 style={{textAlign: "right", width:"100%" }}  className="mb-0 text-dark">{data.EIS_Stat}</h4>
                  </div>
                }
                { (data.Compressor_Stat !== null) &&
                  <div className="d-flex align-items-center">
                    <div style={{flex: "none"}} className="dot-indicator nevy mt-1 mr-2"></div>
                    <h4 style={{flex: "none"}} className="text-muted ml-3">Compressor : &nbsp;</h4>
                    <h4 style={{textAlign: "right", width:"100%" }}  className="mb-0 text-dark">{data.Compressor_Stat}</h4>
                  </div>
                }
              </div>
              <div className="d-flex flex-column justify-content-center border-top border-bottom py-3 mt-3 mb-3">
                { (data.PressHTR_Stat !== null) &&
                  <div className="d-flex align-items-center">
                    <div style={{flex: "none"}} className="dot-indicator bg-warning mt-1 mr-2"></div>
                    <h4 style={{flex: "none"}} className="text-muted ml-3">Press Htr : &nbsp;</h4>
                    <h4 style={{textAlign: "right", width:"100%" }} className="mb-0 text-dark">{data.PressHTR_Stat}</h4>
                  </div>
                }
                { (data.SelfTest_Stat !== null) &&
                  <div className="d-flex align-items-center">
                    <div style={{flex: "none"}} className="dot-indicator bg-warning mt-1 mr-2"></div>
                    <h4 style={{flex: "none"}} className="text-muted ml-3">Self Test : &nbsp;</h4>
                    <h4 style={{textAlign: "right", width:"100%" }} className="mb-0 text-dark">{data.SelfTest_Stat}</h4>
                  </div>
                }

              </div>
              <br></br>

              <div className="d-flex flex-column justify-content-center">
                { (data.SH_Stat !== null) &&
                  <div className="d-flex align-items-center">
                    <div style={{flex: "none"}} className="dot-indicator bg-success mt-1 mr-2"></div>
                    <h4 style={{flex: "none"}} className="text-muted ml-3">SH : &nbsp;</h4>
                    <h4 style={{textAlign: "right", width:"100%" }} className="mb-0 text-dark">{data.SH_Stat}</h4>
                  </div>
                }
                { (data.Buttons !== null) &&
                  <div className="d-flex align-items-center">
                    <div style={{flex: "none"}} className="dot-indicator bg-success mt-1 mr-2"></div>
                    <h4 style={{flex: "none"}} className="text-muted ml-3">Buttons : &nbsp;</h4>
                    <h4 style={{textAlign: "right", width:"100%" }} className="mb-0 text-dark">{data.Buttons}</h4>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInfoWrapper>
  );
};

export default LatestActivity;
